import service from '@/services/superaccess'
const contact = {
  actions: {
    getFaq (context, payload) {
      return service.post('/api/contact/faq', context, { language: payload })
    },
    getSubject (context, payload) {
      return service.post('/api/contact/subject', context, { outside: payload.outside, language: payload.language })
    },
    sendEmail (context, payload) {
      return service.post('/api/contact/email', context, { payload })
    }
  }
}
export default contact



// WEBPACK FOOTER //
// app/javascript/src/store/contact.js